// eslint-disable-next-line no-restricted-imports
import { pino } from 'pino';
import stringify from 'safe-json-stringify';

// we don't use configServerEnv, because it can not be imported in client side code
const isProduction = process.env.NODE_ENV === 'production';

export const Logger = pino({
	browser: {
		serialize: true,
		write: isProduction
			? () => {
					// do not write to console in production
				}
			: undefined,
		transmit: {
			// only transmit error messages
			level: isProduction ? 'error' : 'debug',
			send(level, logEvent) {
				const body = stringify({
					level,
					messages: logEvent.messages,
					bindings: logEvent.bindings,
					time: logEvent.ts,
					browser: {
						url: window.location.href,
						userAgent: navigator.userAgent,
					},
				});

				fetch('clientError', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body,
				}).catch(() => {
					// do not log any errors if error reporting fails
				});
			},
		},
	},
});
